// extracted by mini-css-extract-plugin
export default {"accountHeader":"Ls-z","primeBadge":"Ms-z","logout":"Ns-z"};